import styled from 'styled-components';
import { space } from 'styled-system';

export const Label = styled.label`
    ${space};
    width: 100%;
    position: relative;
`;
